export default __webpack_public_path__ + "static/media/iac-docs.559c411a.svg";